import React, { useMemo, useState } from "react";
import { GALLERY } from "@/lib/site";

const FILTERS = ["All", "Rendering", "Plastering", "Drylining", "Domestic", "Commercial"];

export const Gallery = () => {
  const [filter, setFilter] = useState("All");

  const items = useMemo(() => {
    if (filter === "All") return GALLERY;
    return GALLERY.filter((g) => g.tag === filter || g.type === filter);
  }, [filter]);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-brand-ink"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-brand-gold/90">
              <span className="inline-block h-px w-10 bg-brand-gold" />
              Recent work
            </div>
            <h2 className="mt-4 font-serif text-4xl md:text-6xl text-white leading-tight text-balance">
              The proof is on the{" "}
              <span className="text-brand-gold italic">wall</span>.
            </h2>
          </div>

          <div className="flex flex-wrap gap-2">
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`gallery-filter-${f.toLowerCase()}`}
                className={`px-4 py-2 text-xs uppercase tracking-[0.18em] rounded-sm border transition-all duration-200 ${
                  filter === f
                    ? "bg-brand-gold text-black border-brand-gold"
                    : "border-white/10 text-white/70 hover:border-brand-gold/50 hover:text-brand-gold"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {items.map((g, idx) => (
            <div
              key={g.src + idx}
              data-testid={`gallery-item-${idx}`}
              className={`group relative overflow-hidden rounded-sm border border-white/5 hover:border-brand-gold/40 transition-colors duration-500 ${
                idx % 5 === 0 ? "sm:row-span-2 sm:col-span-1 aspect-[3/4] sm:aspect-auto" : "aspect-[4/3]"
              }`}
            >
              <img
                src={g.src}
                alt={g.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/30 to-transparent opacity-90" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="text-[10px] uppercase tracking-[0.25em] text-brand-gold">
                  {g.tag} · {g.type}
                </div>
                <div className="mt-1 font-serif text-lg md:text-xl text-white">
                  {g.title}
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length === 0 && (
          <div className="mt-12 text-center text-white/60">
            No projects in this category yet — check back soon.
          </div>
        )}
      </div>
    </section>
  );
};
